var _rect, _rect2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCredential(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 87,
    viewBox: "0 0 90 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 90,
    height: 86,
    rx: 12,
    fill: "url(#paint0_linear_1_7086)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.75,
    width: 89.5,
    height: 85.5,
    rx: 11.75,
    stroke: "#E6E6E6",
    strokeOpacity: 0.901961,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("svg", _extends({
    x: 26,
    y: 24.5,
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0835 22.1667C9.34183 22.1667 7.91683 20.7417 7.91683 19C7.91683 17.2583 9.34183 15.8333 11.0835 15.8333C12.8252 15.8333 14.2502 17.2583 14.2502 19C14.2502 20.7417 12.8252 22.1667 11.0835 22.1667ZM19.9502 15.8333C18.6835 12.1917 15.2002 9.5 11.0835 9.5C5.8585 9.5 1.5835 13.775 1.5835 19C1.5835 24.225 5.8585 28.5 11.0835 28.5C15.2002 28.5 18.6835 25.8083 19.9502 22.1667H25.3335V28.5H31.6668V22.1667H36.4168V15.8333H19.9502Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_7086",
    x1: 3.32661,
    y1: 43.5,
    x2: 90.1814,
    y2: 43.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7445FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62D9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredential);
export default __webpack_public_path__ + "static/media/credential.ffef9a99b9bc4316bf027ebb26f6b6d4.svg";
export { ForwardRef as ReactComponent };